import React from 'react';
import styled from 'styled-components';
import Modal from './Modal';
import { AppColors } from '../styles/colors';

interface BidHistoryUpdateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmButton = styled.button`
  width: 100%;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  background-color: ${AppColors.btnCEmphasis};
  color: ${AppColors.onBtnCEmphasis};
  
  &:hover {
    background-color: #262626;
    color: #FFFFFF;
  }
`;

const BidHistoryUpdateModal: React.FC<BidHistoryUpdateModalProps> = ({
  isOpen,
  onClose,
  onConfirm
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header="새로운 입찰이 들어왔습니다"
      body="입찰가 재확인 후 다시 신청 바랍니다."
      footer={
        <ConfirmButton onClick={onConfirm}>
          확인
        </ConfirmButton>
      }
      width="320px"
    />
  );
};

export default BidHistoryUpdateModal;
